export default function (element, data) {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    
    let headerFixed;
    
    if (window.innerWidth > 1100) {
        headerFixed = document.querySelector('.header__bottom');
    } else {
        headerFixed = document.querySelector('.header__center');
    }
    let headerHeight = header.offsetHeight;
    
    function handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let top = headerFixed.offsetHeight * (-1) + "px";
        
        if (scrollTop > lastScrollTop) {
            // Прокрутка вниз
            headerFixed.style.top = top; // Скрываем шапку
            headerFixed.style.position = 'static';
        } else {
            // Прокрутка вверх
            if (scrollTop > headerHeight - headerFixed.offsetHeight) {
                headerFixed.style.top = "0"; // Показываем шапку
                headerFixed.style.position = 'fixed';
            } else {
                headerFixed.style.position = 'static';
            }
        }
        
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для мобильных браузеров, где значение может быть отрицательным
    }
    
    window.addEventListener("scroll", handleScroll);
}